export default __webpack_public_path__ + "static/media/piano.c9aa38c6.gif";